import { useContext, useMemo } from "react";
import StyleContext from "../contexts/StyleContext";
import * as portfolioEn from "../portfolio";
import * as portfolioEs from "../portfolio-es";

/**
 * Custom hook that conditionally returns the appropriate portfolio data based on the current language
 * @returns {Object} Portfolio data object with all sections
 */
const usePortfolio = () => {
  const styleContext = useContext(StyleContext);
  
  // Safely get language from context, default to "en"
  const language = styleContext?.language || "en";
  
  // Conditionally return the portfolio data based on language
  // useMemo ensures we only recalculate when language changes
  // This will cause components to re-render when language changes
  return useMemo(() => {
    if (language === "es") {
      return portfolioEs;
    }
    return portfolioEn;
  }, [language]);
};

export default usePortfolio;

